import api, { buildQueryString } from './api';
import type {
  Customer,
  CustomerStatus,
  PaginatedResponse,
  ApiResponse,
  PaginationParams,
  CreateCustomerForm,
} from '../types';

export interface CustomerFilters extends PaginationParams {
  status?: CustomerStatus;
}

export const customerService = {
  async getAll(params?: CustomerFilters): Promise<PaginatedResponse<Customer>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<Customer>>(`/api/customers${qs}`);
    return response.data;
  },

  async getById(id: string): Promise<Customer> {
    const response = await api.get<ApiResponse<Customer>>(`/api/customers/${id}`);
    return response.data.data;
  },

  async create(data: CreateCustomerForm): Promise<Customer> {
    const response = await api.post<ApiResponse<Customer>>('/api/customers', data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreateCustomerForm>): Promise<Customer> {
    const response = await api.patch<ApiResponse<Customer>>(`/api/customers/${id}`, data);
    return response.data.data;
  },

  async updateStatus(id: string, status: CustomerStatus): Promise<Customer> {
    const response = await api.patch<ApiResponse<Customer>>(`/api/customers/${id}/status`, { status });
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/customers/${id}`);
  },

  async search(query: string): Promise<Customer[]> {
    const response = await api.get<ApiResponse<Customer[]>>(`/api/customers/search?q=${encodeURIComponent(query)}`);
    return response.data.data;
  },
};
